import React from "react";
import BirthdayScreen from "../../Birthday";

const Screen22 = () => {
    return <BirthdayScreen />;
};

export default Screen22;
